import { render } from "./ContactPhoneForm.vue?vue&type=template&id=82cf44b2&ts=true"
import script from "./ContactPhoneForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactPhoneForm.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/contact/components/ContactPhoneForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82cf44b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82cf44b2', __exports__)) {
    api.reload('82cf44b2', __exports__)
  }
  
  module.hot.accept("./ContactPhoneForm.vue?vue&type=template&id=82cf44b2&ts=true", () => {
    api.rerender('82cf44b2', render)
  })

}


export default __exports__